<template>
  <div>
    <el-button size="small" class="margin-bottom-10" type="primary" @click="toGroupAuth()" round><i class="fa fa-plus"></i> 分组授权</el-button>
    <el-table
        class="list-table"
        ref="multipleTable"
        :data="authList"
        border
        tooltip-effect="dark"
        :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
    >
      <template slot="empty">
        <div class="no-data">暂无数据！</div>
      </template>
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="groupId" label="分组编号" width="120"></el-table-column>
      <el-table-column prop="groupName" label="分组名称" width="300"></el-table-column>
      <el-table-column prop="roles" label="角色" min-width="240">
        <template slot-scope="scope">
          <el-tag class="margin-right-5" size="small" effect="plain" v-for="(role, index) in scope.row.roles" :key="index">{{ role.name }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140">
        <template slot-scope="scope">
          <el-button @click="toGroupAuth(scope.row)" type="text" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
          <el-button @click="deleteAuth(scope.row)" type="text" size="small"><i class="fa fa-trash-o"></i> 删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页-->
    <page-bar v-model="page" @change="fetchData"></page-bar>

    <el-dialog :title="curAuth ? '编辑授权' : '添加授权'" :visible.sync="dialogVisible" :destroy-on-close="true" width="780px" class="form-dialog">
      <el-form :rules="rules" ref="groupForm" label-width="80px">
        <el-form-item label="组名称" prop="name">
          <el-select v-model="groupIds" multiple placeholder="请选择" style="width: 40%">
            <el-option v-for="group in groupList" :key="group.id" :value="group.id" :label="group.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <template>
            <el-transfer v-model="roleIds" :props="props" :data="roleList" :titles="['角色名称', '配置角色']"></el-transfer>
          </template>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="doClose()"><i class="fa fa-close"></i> 关闭</el-button>
        <el-button type="primary" @click="saveGroupAuth()"><i class="fa fa-save"></i> 保存 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { batchSaveGroupAuth, fetchGroupAuth, remove } from '@/api/system/auth'
import PageBar from '@components/PageBar'
import { handleConfirm } from '@utils/confirm'
import { fetchAll } from '@api/system/role'
import { findAll } from '@api/system/group'

export default {
  created() {
    this.fetchData()
  },
  components: { PageBar },
  methods: {
    fetchData() {
      fetchGroupAuth({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
      }).then(resp => {
        this.authList = resp.data.result
      })
    },
    deleteAuth(val) {
      handleConfirm('你确定要回收该分组的所有授权吗, 是否继续?').then(() => {
        remove(val).then(resp => {
          this.$message.success(resp.data.message)
          this.fetchData()
        })
      })
    },
    toGroupAuth(row) {
      this.curAuth = row
      this.dialogVisible = true

      this.getGroupEcho()
      this.roleTransfer()
    },
    roleTransfer() {
      fetchAll().then(resp => {
        this.roleList = resp.data.result
      })
    },
    saveGroupAuth() {
      batchSaveGroupAuth(this.groupIds, this.roleIds).then(resp => {
        if (resp.status === 200) {
          this.$message.success(resp.data.message)
          this.dialogVisible = false
          this.fetchData()
        }
      })
    },
    doClose(){
      this.dialogVisible = false
    },
    getGroupEcho() {
      findAll().then(resp => {
        this.groupList = resp.data.result
      })

      if(!this.curAuth){
        this.groupIds = []
        this.roleIds = []
      }else{
        this.groupIds = [this.curAuth.groupId]
        this.roleIds = this.curAuth.roles.map(r=> r.id)
      }
    }
  },
  data() {
    return {
      page: {
        pageSize: 20,
        pageNo: 1
      },
      authList: [],
      curAuth: null,
      dialogVisible:false,
      roleIds: [],
      roleList: [],
      groupList: [],
      groupIds: [],
      echoGroup: {},
      props: {
        key: 'id',
        label: 'name'
      },
      rules: {
        name: [
          { required: true, message: '请选择组名称', trigger: 'blur' },
          { min: 10, max: 20, message: '长度在 10 到 20 个字符', trigger: 'blur' }
        ],
        role: [{ required: true, message: '请选择角色', trigger: 'blur' }]
      }
    }
  }
}
</script>
